import type { RunMetricOutput } from "@/types/RunMetricOutput"
import { getMetricExplanation } from "@/utils/metric-output-boundaries"

import { BinaryMetricRecord } from "./base/BinaryMetricRecord"
import { NumericalMetricRecord } from "./base/NumericalMetricRecord"

function getPythonExplanationSections(output: RunMetricOutput) {
  const explanation = getMetricExplanation(output)
  if (!explanation?.trim()) {
    return null
  }

  return [
    {
      label: "Explanation",
      content: (
        <p className="text-sm text-coval-text whitespace-pre-wrap wrap-break-word">
          {explanation}
        </p>
      ),
    },
  ]
}

function renderPythonExplanation(output: RunMetricOutput) {
  const section = getPythonExplanationSections(output)?.[0]
  return section ? (
    <div className="space-y-2 min-w-0">
      <h3 className="text-sm font-semibold text-coval-text">{section.label}</h3>
      {section.content}
    </div>
  ) : null
}

export class PythonNumericalMetricRecord extends NumericalMetricRecord {
  getDeepDiveSections = getPythonExplanationSections
  _renderDeepDive = renderPythonExplanation
}

export class PythonBinaryMetricRecord extends BinaryMetricRecord {
  getDeepDiveSections = getPythonExplanationSections
  _renderDeepDive = renderPythonExplanation
}
